<div class="bciti-icon-select-container" [ngStyle]="{ 'width': width }">
  <label>{{ 'common.icon' | translate }}</label>
  <div class="bciti-select"
    [class.valid]="valid"
    [class.invliad]="invalid"
    [class.touched]="touched"
    [class.validation]="validation"
    (click)="showDropdown()" 
    #drop
  >
    <div class="bciti-icon-select-option option-selected">
      <span [ngClass]="value"></span>
      <span class="icon-caret-down"></span>
    </div>
    <app-bciti-select-grid-dropdown [reference]="drop">
      <div class="bciti-icon-select-option grid-option" *ngFor="let icon of icons" (click)="select(icon)">
        <span [ngClass]="icon"></span>
      </div>
    </app-bciti-select-grid-dropdown>
  </div>
</div>